


export const LOCALS = {

    en: {
        translation: {
            "label-no-records": "No records found",
            "label-view-file": "View File",
            "label-description": "Description",
            "label-publish-date": "Publishing Date",
            "label-year": "Year",
            "label-8k": "8K",
            "label-1Q": "1Q",
            "label-2Q": "2Q",
            "label-3Q": "3Q",
            "label-10Q": "10Q",
            "label-10K": "10K",
            "label-proxy": "Proxy",
            "label-annual-report": "Annual Report",
            "label-other": "Other",
            "label-regresar": "Go Back",
            "label-file-name": "File Name",
            "label-last-update": "Last update",
            "label-file-size": "File Size",
            "label-month": "Month",
            "label-zone": "Zone",
            "label-region": "Region",
            "label-year-filter": "Year Filter",
            "label-show-all": "Show All",
            "label-Zona-filter": "Zone",
            "label-inspection-date": "Inspection Date"
        }
    },
    esp: {
        translation: {
            "label-no-records": "No se encontraron registros",
            "label-view-file": "Ver Archivo",
            "label-description": "Descripción",
            "label-publish-date": "Fecha de Publicación",
            "label-year": "Año",
            "label-8k": "8K",
            "label-1Q": "1Q",
            "label-2Q": "2Q",
            "label-3Q": "3Q",
            "label-10Q": "10Q",
            "label-10K": "10K",
            "label-proxy": "Proxy",
            "label-annual-report": "Reporte Anual",
            "label-other": "Otros",
            "label-regresar": "Regresar",
            "label-file-name": "Nombre del Archivo",
            "label-last-update": "Última Actualización",
            "label-file-size": "Tamaño de Archivo",
            "label-month": "Mes",
            "label-zone": "Zona",
            "label-region": "Región",
            "label-year-filter": "Filtrar por Año",
            "label-show-all": "Mostrar todos",
            "label-Zona-filter": "Zona",
            "label-inspection-date": "Fecha de Inspección"
        }
    }

}